export default __webpack_public_path__ + "static/media/icon-holiday.563a7aa1.svg";